import { Injectable } from "@angular/core";
import { UserAddressService } from "../../../../common/services/api/resources/userAddress/user-address.service";
import { distinctUntilKeyChanged } from "rxjs/operators";

const debug = false;

@Injectable({ providedIn: "root" })
export class SignUpUserAddressService extends UserAddressService {
  constructor() {
    super();

    this.session.state.pipe(distinctUntilKeyChanged("sessionId")).subscribe(state => {
      if (state.loggedIn && !!state.sessionId) this.onLogin();
      else if (!state.loggedIn) this.dispose();
    });
  }

  private onLogin(): void {
    debug && console.log("SignupUserAddressService.onLogin");
    this.userAddressBrowse();
  }
}
